"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _get2 = _interopRequireDefault(require("lodash/get"));

var targetService = {
  getTargetOffer: function getTargetOffer(name) {
    if (process.env.IS_BROWSER && (0, _get2.default)(window, 'adobe.target')) {
      var target = window.adobe.target;
      var offerPromise = new Promise(function (resolve, reject) {
        target.getOffer({
          mbox: name,
          success: resolve,
          error: reject
        });
      });
      return offerPromise;
    } else {
      return Promise.resolve({});
    }
  }
};
var _default = targetService;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/experiment/v2/targetService.js
// module id = 3878
// module chunks = 25